// PullIndicator — 당겨서 새로고침 시각 피드백 (usePullToRefresh와 짝)
// 당김 거리(pull)만큼 높이를 가진 상단 영역. 임계 도달 전/후/새로고침중 3상태 라벨.
// TODO(항목4): 스피너 자리에 캐릭터 모션(MotionLoader) 얹어 독창적 로더로 교체 예정.
import React from 'react';

export function PullIndicator({ pull, refreshing, threshold = 70 }) {
  if (pull <= 0 && !refreshing) return null;
  const ready = pull >= threshold;
  const label = refreshing ? '새로고침 중…' : ready ? '놓으면 새로고침' : '당겨서 새로고침';
  return (
    <div
      style={{
        height: pull,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // 놓았을 때만 부드럽게 원위치 — 당기는 중엔 손가락에 즉시 붙도록 transition 없음
        transition: refreshing ? 'none' : 'height .22s ease',
      }}
      aria-hidden="true"
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, opacity: Math.min(1, pull / threshold) }}>
        <span
          style={{
            width: 16,
            height: 16,
            border: '2px solid var(--cs-line-2)',
            borderTopColor: 'var(--cs-accent)',
            borderRadius: '50%',
            // 새로고침 중엔 회전 애니, 당기는 중엔 거리 비례 정적 회전
            animation: refreshing ? 'ptr-spin .7s linear infinite' : 'none',
            transform: refreshing ? 'none' : `rotate(${Math.round(pull * 2.6)}deg)`,
          }}
        />
        <span style={{ fontSize: 12.5, color: 'var(--cs-mute)', fontWeight: 600 }}>{label}</span>
      </div>
      <style>{`@keyframes ptr-spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
